var image_upload_default = {
  "container": "_8uArd",
  "disabled": "_9-vXC",
  "imageInput": "Za7I1",
  "overlay": "VKoIM",
  "text": "xcJp-",
  "shown": "u8DNf",
  "hide": "TY-4N",
  "spinner": "q4siN",
  "spin": "cs4nB"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
